import React, { useRef } from "react"
import Box from "@mui/material/Box"
import { List, ListItem } from "@mui/material";
import { useWindowDimensions } from "../../../App";
import { renderTopGroupState } from "./CheckingModifier";
import { logger } from "../../../utils/logger";

const ModifierStatusList = (props: { itemDetail: any; setItemDetail: any; }) => {
  const {itemDetail} = props;
  const { height } = useWindowDimensions();
  const itemRefs = useRef<any[]>([]);

  
  const scrollToSection = ( id: string, idx: number) => {
    logger.debug(`Scrolling to: ${id} ${itemRefs.current[idx]}`);
    setTimeout(() => {
      const element = document.getElementById(id);
      if (!element) {
        logger.warn(`❌ Element with id "${id}" not found`);
        return;
      }
      element.scrollIntoView({ behavior: "smooth", block: "start" })
    }, 300);
  };

  return (
    <Box sx={{
      flex: 1, 
      height: `calc(calc(var(--vh, 1vh) * 100) - 17rem)`,
      ml: '1.0rem',
      overflow: 'hidden'
    }}>
      <List style={{ 
        overflow: 'overlay', 
        overflowX: 'hidden', 
        marginTop: '.4rem', 
        height: '100%',
        maxHeight: 'calc(100% - 3.0rem)'
      }}>
        {itemDetail.modifierGroups.map((group: any, groupIdx: number) => {
          return (
            <ListItem
              key={groupIdx}
              sx={{ backgroundColor: '#fff', p: 0, }}
              ref={(el) => (itemRefs.current[groupIdx] = el)}
              onTouchStart={()=>scrollToSection(`header-${groupIdx + 1}`, groupIdx)}>
              <Box sx={{
                minHeight: '13.0rem', 
                border: '1.5px solid #000', 
                display: 'flex', 
                flexDirection: 'row', 
                backgroundColor: '#fdfdfd', 
                p: '2.0rem .5rem', 
                mb: '1.0rem', 
                borderRadius: '.5rem', 
                width: '100%'
              }}>
                {renderTopGroupState(group, groupIdx)}
              </Box>
            </ListItem>)
        })}
      </List>
    </Box>
  )
}

export default ModifierStatusList


